import { Link as RouterLink } from "react-router-dom";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Toolbar from "@mui/material/Toolbar";
import { BrandLockup } from "../components/Brand";
import { ColorModeToggle } from "../components/ColorModeToggle";
import { NamespaceGuide } from "../modules/onboarding/NamespaceGuide";
import { VersionLine } from "../components/VersionLine";

/**
 * The namespace guide at its own URL.
 *
 * 🔑 Same component the registration form opens in a dialog, so the two cannot
 * drift. A provider can be sent this link before they ever reach the form —
 * which is the point, since the name is permanent once chosen.
 */
export function NamespaceDoc() {
  return (
    <Box sx={{ minHeight: "100dvh", bgcolor: "background.default" }}>
      <AppBar position="static" color="default" elevation={0}>
        <Toolbar>
          <BrandLockup to="/welcome" />
          <ColorModeToggle />
          <Button size="small" component={RouterLink} to="/register">
            Register
          </Button>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" sx={{ py: { xs: 3, md: 5 } }}>
        <Paper variant="outlined" sx={{ p: { xs: 2, md: 4 } }}>
          <NamespaceGuide />
        </Paper>
      <VersionLine />
      </Container>
    </Box>
  );
}
